export default "__VITE_ASSET__0e3ad05d__"